import { Lightning, Utils } from '@lightningjs/sdk'

export default class PlayButton extends Lightning.Component {
  static _template() {
    return {
      w: 100,
      h: 100,
      ButtonImage: { w: 100, h: 100 },
    }
  }
  set buttonType(tp) {
    this._initialButtonType = tp
    this.butnType = tp
  }

  set butnType(tp) {
    this._buttonType = tp

    switch (tp) {
      case 'backward':
        this.buttonImg = 'playButtonBack100'
        break
      case 'forward':
        this.buttonImg = 'playButtonForward100'
        break
      case 'playstop':
      case 'playpause':
        this.buttonImg = 'playButton100'
        break
      case 'stop':
        this.buttonImg = 'stopButton100'
        break
      case 'pause':
        this.buttonImg = 'pauseButton100'
        break
    }

    this._fillIcon(false)
  }

  set setState(state) {
    switch (state) {
      case 'play':
      case 'playPause':
      case 'playing':
        if (this._initialButtonType === 'playstop' || this._initialButtonType === 'stop') {
          this.butnType = 'stop'
        } else {
          this.butnType = 'pause'
        }
        break
      case 'pause':
        this.butnType = 'playpause'
        break
      case 'stop':
        this.butnType = 'playstop'
        break
    }
  }

  get buttonType() {
    return this._buttonType
  }

  set size(sz) {
    this._sz = sz

    this.patch({
      w: sz,
      h: sz,
      ButtonImage: { w: sz, h: sz },
    })
  }

  _init() {
    this._hasFocus = false
  }
  OnGpStateChange({ playbuttonState }) {
    if (
      this._initialButtonType === 'playstop' ||
      this._initialButtonType === 'playpause' ||
      this._initialButtonType === 'stop' ||
      this._initialButtonType === 'pause'
    ) {
      this.setState = playbuttonState.toLowerCase()
    }
  }

  _focus() {
    this._hasFocus = true

    this._fillIcon(true)
  }

  _unfocus() {
    this._hasFocus = false

    this._fillIcon(false)
  }

  _fillIcon(tp, focus = false) {
    this.tag('ButtonImage').src = Utils.asset(
      `images/playerbuttons/${this.buttonImg}${this._hasFocus === true ? 'f' : 'n'}.png`
    )
  }
}
